import { ServiceInfo } from '../interfaces/service-info.interface';
import { microfrontendSources } from '../microfrontend-sources';
import { getServiceVersion } from './getServiceVersion';

export function saveVersionOfApplications(services: ServiceInfo[]): void {
    const sources = Object.values(microfrontendSources);
    sources.forEach(source => {
        const curVersion = sessionStorage.getItem(source.id);
        const newServiceVersion = getServiceVersion(
            services,
            source.servicePrefix,
        );

        if (curVersion === newServiceVersion || newServiceVersion === null) {
            return;
        }

        sessionStorage.setItem(source.id, newServiceVersion);
    });
}
